import React, { useState, useReducer } from 'react';
import produce from 'immer';
import { FormControl, InputLabel } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import { connect } from 'react-redux';
import { format } from 'd3-format';
import { layoutReducer } from '../../../reducers/layoutReducer';
import ScatterPlot from './ScatterPlot';

import './common/Chart.css';
import GraphSelect from '../GraphSelect';
import { graphReducer } from '../../../reducers/graphReducer';

import { useChartDimensions, getGraphDataAsMap, dataPerChannel } from './common/utils';
import { Channels } from '../../constants/graphTypes';
import AreaDensity from './AreaDensity';

// Declare metrics/accessors

const fields = {
  type: {
    accessor: d => d.type,
    title: 'Channel Number',
    formatter: d => d,
  },

  sign: {
    accessor: d => d.sign,
    title: 'Channel Sign',
    formatter: d => d,
  },

  x: {
    accessor: d => d.x,
    title: 'Time Secs',
    formatter: format('.2g'),
  },

  y: {
    accessor: d => d.y,
    title: 'Y Axis', // retrived from channel
    formatter: d => d,
  },

  channel: {
    accessor: d => d.channel,
    title: 'X Axis',
    formatter: d => d,
  },
};

const initialState = {
  channel: 'Ch1',
  channelData: null,
};
const curryiedGraphReducer = produce(graphReducer);

const Amplitude1D = ({ graphData, activeChannels }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
  } = useForm();
  const data = getGraphDataAsMap(graphData);
  console.log({ data });
  const [mapValue, setMapValue] = useState('scatter');
  const visibleChannels = activeChannels ? Channels.filter(c => activeChannels.includes(c.name)) : Channels;
  const defaultChannel = visibleChannels[0]?.name ?? 'Ch1';
  const initalizeStateLazily = () => ({
    channel: defaultChannel,
    channelData: dataPerChannel(data, defaultChannel),
  });

  const [state, dispatch] = useReducer(curryiedGraphReducer, initialState, initalizeStateLazily);

  // Read from predefined metric(fields)

  const xFields = fields.x;
  const yFields = fields.y;

  // accessor functions for scatter plot
  const { accessor: xAccessor, title: xTitle, formatter: xFormatter } = xFields;
  const { accessor: yAccessor, title: yTitle, formatter: yFormatter } = yFields;

  const ref = React.useRef(null);

  const { width, height } = useChartDimensions(ref);

  const { channel, channelData } = state;

  const handleMapToggle = e => {
    setMapValue(e.target.value);
  };

  const handleSelectedChannel = e => {
    const chData = dataPerChannel(data, e.target.value);
    dispatch({ type: e.target.value, payload: chData });
  };

  return (
    // graphData.layoutReducer.width && graphData.layoutReducer.height &&
    channelData &&
    channel && (
      <React.Fragment>
        <div id="channels">
          <FormControl variant="standard" sx={{ m: 1, minWidth: 240 }}>
            <InputLabel id="demo-simple-select-standard-label">Channels</InputLabel>

            <GraphSelect graph={visibleChannels} defaultValue={channel} onSelect={handleSelectedChannel} />
          </FormControl>
        </div>

        <div id="controls">
          <button
            className={`button ${mapValue === 'scatter' ? 'current' : ' '}`}
            value="scatter"
            onClick={handleMapToggle}
          >
            Scatter
          </button>
          <button
            className={`button ${mapValue === 'density' ? 'current' : ''}`}
            value="density"
            style={{ marginLeft: 10 }}
            onClick={handleMapToggle}
          >
            Density
          </button>
        </div>

        {mapValue === 'scatter' && (
          <div className="graphborder graphborder-dashed border-cyan-500" ref={ref} style={{ height: 450 }}>
            <ScatterPlot
              width={width}
              height={height}
              channel={channel}
              data={channelData}
              xAccessor={xAccessor}
              yAccessor={yAccessor}
              xLabel={xTitle}
              yLabel={channel}
              xFormatter={xFormatter}
              yFormatter={yFormatter}
              graphType={'1D'}
            />
          </div>
        )}

        {mapValue === 'density' && (
          <div className="graphborder graphborder-dashed border-cyan-500" ref={ref} style={{ height: 450 }}>
            <AreaDensity data={channelData} channel={channel} width={width} height={height} />
          </div>
        )}
      </React.Fragment>
    )
    //: <div>Please wait.. width and height are being calcualted..</div>
  );
};

const stateToProps = state => ({
  layoutReducer: state.layoutReducer,
});

//Amplitude1D.whyDidYouRender = true;
//export default Amplitude1D;
export default connect(stateToProps, null)(Amplitude1D);
